/**
 * Trust Score visual — circular progress ring.
 *
 * Pure SVG, no charting library. Tier color comes from `tier`:
 *   getting_started -> slate (no color),
 *   verified_student -> emerald,
 *   trusted_student -> amber/gold.
 *
 * IMPORTANT: This is a Sturent Trust Score. It is NOT a credit score and
 * MUST NOT be presented as endorsed by Equifax, TransUnion, Borrowell, etc.
 */
const TIER_COLORS = {
  getting_started: { ring: '#94A3B8', text: '#475569', label: 'Getting started' },
  verified_student: { ring: '#10B981', text: '#047857', label: 'Verified student' },
  trusted_student: { ring: '#F59E0B', text: '#B45309', label: 'Trusted student' },
};

const TrustScoreRing = ({ score = 0, tier = 'getting_started', size = 96, strokeWidth = 8, showLabel = true }) => {
  const t = TIER_COLORS[tier] || TIER_COLORS.getting_started;
  const radius = (size - strokeWidth) / 2;
  const c = 2 * Math.PI * radius;
  const filled = (Math.min(Math.max(score, 0), 100) / 100) * c;
  return (
    <div className="inline-flex flex-col items-center" data-testid="trust-score-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#E5E7EB"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={t.ring}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={`${filled} ${c}`}
          style={{ transition: 'stroke-dasharray 0.6s ease' }}
        />
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          transform={`rotate(90 ${size / 2} ${size / 2})`}
          className="font-heading font-bold"
          fontSize={size * 0.28}
          fill="#0F172A"
        >
          {score}
        </text>
      </svg>
      {showLabel && (
        <p className="mt-2 text-xs font-semibold uppercase tracking-wider" style={{ color: t.text }}>
          {t.label}
        </p>
      )}
    </div>
  );
};

export default TrustScoreRing;
